import { formatDateWithLocalTZ } from "@ticomix/common";
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import { IAuthUserInfo } from "./i-iauth-user-info";
import { throwException, blobToText } from "./api-utilities";

export class AuthUserInfo implements IAuthUserInfo {
  Email?: string | null;
  UserName?: string | null;
  FirstName?: string | null;
  LastName?: string | null;
  PhoneNumber?: string | null;
  Roles!: string[];
  TwoFactorEnabled!: boolean;
  LastLogin?: Date | null;

  constructor(data?: IAuthUserInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.Roles = [];
      this.TwoFactorEnabled = false;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.Email = _data["Email"] !== undefined ? _data["Email"] : <any>null;
      this.UserName =
        _data["UserName"] !== undefined ? _data["UserName"] : <any>null;
      this.FirstName =
        _data["FirstName"] !== undefined ? _data["FirstName"] : <any>null;
      this.LastName =
        _data["LastName"] !== undefined ? _data["LastName"] : <any>null;
      this.PhoneNumber =
        _data["PhoneNumber"] !== undefined ? _data["PhoneNumber"] : <any>null;
      if (Array.isArray(_data["Roles"])) {
        this.Roles = [] as any;
        for (let item of _data["Roles"]) this.Roles!.push(item);
      } else {
        this.Roles = <any>null;
      }
      this.TwoFactorEnabled =
        _data["TwoFactorEnabled"] !== undefined
          ? _data["TwoFactorEnabled"]
          : false;
      this.LastLogin = _data["LastLogin"]
        ? new Date(_data["LastLogin"].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): AuthUserInfo {
    data = typeof data === "object" ? data : {};
    let result = new AuthUserInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Email"] = this.Email !== undefined ? this.Email : <any>null;
    data["UserName"] = this.UserName !== undefined ? this.UserName : <any>null;
    data["FirstName"] =
      this.FirstName !== undefined ? this.FirstName : <any>null;
    data["LastName"] = this.LastName !== undefined ? this.LastName : <any>null;
    data["PhoneNumber"] =
      this.PhoneNumber !== undefined ? this.PhoneNumber : <any>null;
    if (Array.isArray(this.Roles)) {
      data["Roles"] = [];
      for (let item of this.Roles) data["Roles"].push(item);
    }
    data["TwoFactorEnabled"] =
      this.TwoFactorEnabled !== undefined ? this.TwoFactorEnabled : <any>null;
    data["LastLogin"] = this.LastLogin
      ? formatDateWithLocalTZ(this.LastLogin)
      : <any>null;
    return data;
  }
}
